import getSegmentByEZ from '@/helpers/getSegmentByEZ'
import hsOrderTypes from '@/resources/enums/hsOrderTypes'

// HSS-748: Bei PremiumCars sehen Makler keinen Preis, bis aus der Anfrage ein Angebot geworden ist.
// Wer Anfragen bearbeitet, braucht den Preis fuer das Angebot und sieht ihn weiter.
export default function isPreisAufAnfrage (order, can) {
  if (can('processAnfragen')) return false
  if (order.hsOrderType && order.hsOrderType !== hsOrderTypes.ANFRAGE.api) return false
  if (!order.carData || !order.carData.erstzulassung) return false
  return getSegmentByEZ(order.carData.erstzulassung) === 'PremiumCars'
}
